import { CompanyCreationDocumentType } from '__generated__/GQL';

import { State } from '../../machine';
import model from '../../machine/model';
import { getCreationDocumentStatus } from '../getCreationDocumentStatus';
import locales from './locales';
import { GetVerificationStep } from './types';

const getNoCriminalConvictionStatementStep: GetVerificationStep = (context) => {
  return {
    errors: [],
    id: State.NO_CRIMINAL_CONVICTION_STATEMENT,
    metadata: {
      description: {
        add: locales.noCriminalConvictionStatement.estimatedTime,
      },
      event: model.events.GO_NO_CRIMINAL_CONVICTION_STATEMENT(),
      iconName: 'legal',
      label: {
        add: locales.noCriminalConvictionStatement.label,
        review: locales.noCriminalConvictionStatement.label,
      },
    },
    status: getCreationDocumentStatus(
      CompanyCreationDocumentType.NoCriminalConvictionStatement,
      context,
    ),
  };
};

export default getNoCriminalConvictionStatementStep;
